import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { MenuState, TAppMenu, TMenuIds, TPosition } from "./types";
import { APP_MENUS } from "./constant";

const initialState: MenuState = {
  appMenu: APP_MENUS,
};

const menuSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {
    updateMenu: (
      state,
      action: PayloadAction<Partial<TAppMenu> & { id: TMenuIds }>,
    ) => {
      const { id, ...payload } = action.payload;
      if (!state.appMenu[id]) return;

      state.appMenu[id] = {
        ...state.appMenu[id],
        ...payload,
      };
    },
    updateMenuPosition: (
      state,
      action: PayloadAction<{ id: TMenuIds; position: TPosition } | null>,
    ) => {
      if (!action.payload) return;
      const { id, position } = action.payload;
      state.appMenu[id].position = position;
    },
    closeMenu: (state, action: PayloadAction<{ id: TMenuIds }>) => {
      const { id } = action.payload;
      if (state.appMenu[id]) {
        state.appMenu[id].isOpen = false;
        state.appMenu[id].parentId = undefined;
        state.appMenu[id].position = null;
      }
    },
  },
});

export const menuReducers = menuSlice.reducer;
export const { updateMenu, updateMenuPosition, closeMenu } = menuSlice.actions;
